import React, { useState, useEffect } from "react";
import NavBar from "./NavBar";
import Footer from "./Footer";
import { Helmet } from "react-helmet-async";

// Import all gallery images
import img1 from "../images/gallery/20230726_113441.jpg";
import img2 from "../images/gallery/20230818_160144.jpg";
import img3 from "../images/gallery/20230830_132103.jpg";
import img4 from "../images/gallery/20230830_135250.jpg";
import img5 from "../images/gallery/20230903_131950.jpg";
import img6 from "../images/gallery/20230922_130544.jpg";
import img7 from "../images/gallery/20230927_095013.jpg";
import img8 from "../images/gallery/20231011_150517.jpg";
import img9 from "../images/gallery/20231013_121523.jpg";
import img10 from "../images/gallery/20231206_092500.jpg";
import img11 from "../images/gallery/20240104_102903.jpg";
import img12 from "../images/gallery/20240129_094650.jpg";
import img13 from "../images/gallery/20240129_095118.jpg";
import img14 from "../images/gallery/20240130_125936.jpg";
import img15 from "../images/gallery/20240212_092343.jpg";
import img16 from "../images/gallery/20240216_150805.jpg";
import img17 from "../images/gallery/20240220_113946.jpg";
import img18 from "../images/gallery/20240221_221021-COLLAGE.jpg";
import img19 from "../images/gallery/20240227_153427.jpg";
import img20 from "../images/gallery/20240309_124248.jpg";
import img21 from "../images/gallery/20240312_202726-COLLAGE.jpg";
import img22 from "../images/gallery/20240324_141057.jpg";
import img23 from "../images/gallery/20240326_093220.jpg";
import img24 from "../images/gallery/20240327_125252.jpg";
import img25 from "../images/gallery/20240330_115311.jpg";
import img26 from "../images/gallery/20240424_120344.jpg";
import img27 from "../images/gallery/20240502_105845.jpg";
import img28 from "../images/gallery/20240603_091541.jpg";
import img29 from "../images/gallery/20240605_161817.jpg";
import img30 from "../images/gallery/20240606_111458.jpg";
import img31 from "../images/gallery/20240606_121347.jpg";
import img32 from "../images/gallery/20240607_082134.jpg";
import img33 from "../images/gallery/20240607_171328.jpg";
import img34 from "../images/gallery/20240617_152700.jpg";
import img35 from "../images/gallery/20240703_142147.jpg";
import img36 from "../images/gallery/20240703_154204.jpg";
import img37 from "../images/gallery/20240711_100152.jpg";
import img38 from "../images/gallery/20240823_125907.jpg";
import img39 from "../images/gallery/20240827_143542.jpg";
import img40 from "../images/gallery/20240827_155021.jpg";
import img41 from "../images/gallery/20240903_135405.jpg";
import img42 from "../images/gallery/20240911_100247.jpg";
import img43 from "../images/gallery/20240911_100612.jpg";
import img44 from "../images/gallery/20240911_112608.jpg";
import img45 from "../images/gallery/20240911_120857.jpg";
import img46 from "../images/gallery/20240913_133907.jpg";
import img47 from "../images/gallery/20241001_135829.jpg";
import img48 from "../images/gallery/20241004_102253.jpg";
import img49 from "../images/gallery/20241004_102407.jpg";
import img50 from "../images/gallery/20241025_135440.jpg";
import img51 from "../images/gallery/20241026_094211.jpg";
import img52 from "../images/gallery/20241026_095320.jpg";
import img53 from "../images/gallery/20241026_103541.jpg";
import img54 from "../images/gallery/20241128_111814.jpg";
import img55 from "../images/gallery/20241203_123225.jpg";
import img56 from "../images/gallery/20241206_145201.jpg";
import img57 from "../images/gallery/20241207_122725.jpg";
import img58 from "../images/gallery/20241209_095023.jpg";
import img59 from "../images/gallery/20241212_093909.jpg";
import img60 from "../images/gallery/20250120_162816.jpg";
import img61 from "../images/gallery/20250304_165133.jpg";
import img62 from "../images/gallery/20250312_094518.jpg";
import img63 from "../images/gallery/20250312_120740.jpg";
import img64 from "../images/gallery/20250312_120759.jpg";
import img65 from "../images/gallery/20250312_120811.jpg";
import img66 from "../images/gallery/20250402_114733.jpg";
import img67 from "../images/gallery/20250402_154309.jpg";
import img68 from "../images/gallery/20250402_160115.jpg";
import img69 from "../images/gallery/20250404_150908.jpg";
import img70 from "../images/gallery/20250412_142804.jpg";
import img71 from "../images/gallery/20250417_134119.jpg";
import img72 from "../images/gallery/20250424_103054.jpg";
import img73 from "../images/gallery/20250424_103134.jpg";
import img74 from "../images/gallery/20250430_085944.jpg";
import img75 from "../images/gallery/20250430_085956.jpg";
import img76 from "../images/gallery/20250608_095857.jpg";
import img77 from "../images/gallery/20250608_102612.jpg";
import img78 from "../images/gallery/20250818_110056.jpg";
import img79 from "../images/gallery/20250901_084339.jpg";
import img80 from "../images/gallery/20250910_145312.jpg";
import img81 from "../images/gallery/20251002_095652.jpg";
import img82 from "../images/gallery/20251008_142240.jpg";
import img83 from "../images/gallery/20251008_150241.jpg";
import img84 from "../images/gallery/20251017_095525.jpg";
import img85 from "../images/gallery/20251118_143101.jpg";
import img86 from "../images/gallery/20251120_162546.jpg";
import img87 from "../images/gallery/image000000(12).jpg";
import img88 from "../images/gallery/image000000(39).jpg";
import img89 from "../images/gallery/image000000(46).jpg";
import img90 from "../images/gallery/image000000(74).jpg";
import img91 from "../images/gallery/IMG_20240324_214022.jpg";
import img92 from "../images/gallery/IMG_20240419_181448.jpg";
import img93 from "../images/gallery/IMG_20240828_090820.jpg";
import img94 from "../images/gallery/Screenshot_20240225_201305_Messages.jpg";

const galleryImages = [
  img1, img2, img3, img4, img5, img6, img7, img8, img9, img10,
  img11, img12, img13, img14, img15, img16, img17, img18, img19, img20,
  img21, img22, img23, img24, img25, img26, img27, img28, img29, img30,
  img31, img32, img33, img34, img35, img36, img37, img38, img39, img40,
  img41, img42, img43, img44, img45, img46, img47, img48, img49, img50,
  img51, img52, img53, img54, img55, img56, img57, img58, img59, img60,
  img61, img62, img63, img64, img65, img66, img67, img68, img69, img70,
  img71, img72, img73, img74, img75, img76, img77, img78, img79, img80,
  img81, img82, img83, img84, img85, img86, img87, img88, img89, img90,
  img91, img92, img93, img94
];

// Number of images to preload before showing gallery (covers initial viewport)
const PRELOAD_COUNT = 16;

export default function Gallery() {
  const [loadingPhase, setLoadingPhase] = useState("preloading"); // "preloading" | "rendering" | "ready"
  const [loadedCount, setLoadedCount] = useState(0);

  // Only preload the first batch of images for faster initial load
  useEffect(() => {
    let loaded = 0;
    const imagesToPreload = galleryImages.slice(0, PRELOAD_COUNT);

    imagesToPreload.forEach((src) => {
      const img = new Image();
      img.src = src;
      img.onload = img.onerror = () => {
        loaded++;
        setLoadedCount(loaded);
        if (loaded === PRELOAD_COUNT) {
          // First batch loaded, now render gallery hidden
          setLoadingPhase("rendering");
        }
      };
    });
  }, []);

  // After rendering hidden, wait for layout to complete then show
  useEffect(() => {
    if (loadingPhase === "rendering") {
      // Wait for browser to complete layout calculations
      // Small timeout ensures CSS columns have fully calculated
      const timer = setTimeout(() => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            setLoadingPhase("ready");
          });
        });
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [loadingPhase]);

  const showSpinner = loadingPhase !== "ready";
  const showGallery = loadingPhase === "rendering" || loadingPhase === "ready";
  const galleryVisible = loadingPhase === "ready";

  return (
    <>
      <Helmet>
        <title>Gallery</title>
        <meta name="description" content="Our Shop Gallery" />
        <link rel="canonical" href="/gallery" />
      </Helmet>

      <div className="flex flex-col bg-background bg-fixed bg-cover min-h-screen">
        <NavBar />
        <div className="flex flex-col items-center justify-center text-center flex-1">
          <h1 className="font-BankGothicMDBT items-center mb-7 mt-36 font-bankgothic text-7xl text-white ">
            Gallery
          </h1>

          {showSpinner && (
            <div className="flex flex-col items-center justify-center py-24 absolute left-1/2 transform -translate-x-1/2">
              <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin mb-4"></div>
              <p className="text-white text-lg whitespace-nowrap">
                Loading images... <span className="inline-block w-8 text-right">{loadedCount}</span> / {PRELOAD_COUNT}
              </p>
            </div>
          )}

          {showGallery && (
            <div 
              className={`columns-1 md:columns-2 lg:columns-3 xl:columns-4 gap-4 px-2 sm:px-8 md:px-16 lg:px-24 pb-24 transition-opacity duration-500 ${
                galleryVisible ? "opacity-100" : "opacity-0"
              }`}
              style={{ visibility: galleryVisible ? "visible" : "hidden" }}
            >
              {galleryImages.map((image, index) => (
                <div key={index} className="mb-4 break-inside-avoid">
                  <img
                    src={image}
                    alt={`Gallery image ${index + 1}`}
                    loading={index < PRELOAD_COUNT ? "eager" : "lazy"}
                    className="w-full h-auto rounded-lg hover:opacity-90 transition-opacity cursor-pointer"
                  />
                </div>
              ))}
            </div>
          )}
        </div>
        <Footer />
      </div>
    </>
  );
}
